import React, { Component } from 'react'
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js'
import ItemMasterServices from '../../services/axioServices/apiServices/ItemMasterServices.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import QCMonogramCommon from '../../components/master/QCMonogramCommon.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CommonValidationMessages } from '../../utils/Messages.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';

export default class QCMonogramPackingMaterial extends Component {
  constructor(props) {
    super(props);
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      openModel: false,
      packingMaterialList: [],
      packingMaterialObject: {
        packingMaterialId: "",
        specification: ""
      },
      testDetails: {
        monoGramId: "",
        testId: "",
        testName: "",
        result: "",
        limit: "",
        isOwnLaboratory: 0,
      },
      tableData: [],
      columns: [
        { field: 'testName', header: 'Test Name', width: '30%' },
        { field: 'result', header: 'Result', width: '20%' },
        { field: 'limit', header: 'Limit', width: '20%' },
        { field: 'isOwnLaboratory', header: 'At Own Lab', width: '15%' },
        { field: 'action', header: 'Action', body: this.actionTemplate, sortable: false, width: '15%', headerClassName: 'head-center', }
      ],
      validationRules: {
        testId: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "isOwnLaboratory name"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    }
  }

  componentDidMount() {
    this.getAllPackingMaterialDropdown();
  }

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
          uom: item.pmUOM,
          specification: item.specification
        }));
        this.setState({ packingMaterialList: dropdownItems }, () => {
          this.getAllTestMaster();
        });
      } else {
        this.SwalServices.Error(response.Message);
        this.getAllTestMaster();
      }
    });
  };

  getAllTestMaster = () => {
    this.commonServices.getAllTestMaster().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.testName,
          value: item._id,
        }));
        this.setState({ testMasterList: dropdownItems })
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    let details = this.state.testDetails;
    details[name] = value.toUpperCase();
    this.setState({ testDetails: details });
  };

  toggleModal = () => {
    this.setState({ openModel: !this.state.openModel })
  }

  handleToggle = (e) => {
    let checked = e.target.checked;
    this.setState({
      testDetails: {
        ...this.state.testDetails,
        isOwnLaboratory: checked ? 1 : 0
      }
    });
  }

  actionTemplate = (rowData) => {
    return (
      <div className="flex items-center justify-center gap-2">
        <button
          className="search-btn w-[28px] h-[28px] bg-blue text-white rounded"
          onClick={() => this.handleEdit(rowData)}
        >
          <FontAwesomeIcon icon={faPen} className='w-[14px] h-[14px]' />
        </button>
        <button
          className="cancel-btn w-[28px] h-[28px] bg-red-500 text-white rounded hover:bg-red-600"
          onClick={() => this.handleDelete(rowData)}
        >
          <FontAwesomeIcon icon={faTrash} className='w-[14px] h-[14px]' />
        </button>
      </div>
    );
  };

  handleEdit = (rowData) => {
    this.setState({
      testDetails: {
        monoGramId: rowData._id,
        testName: rowData.testName,
        testId: rowData.testId,
        result: rowData.result,
        limit: rowData.limit,
        isOwnLaboratory: rowData.isOwnLaboratory === 'Yes' ? 1 : 0
      },
      openModel: true
    });
  }

  handleDelete = (rowData) => {
    this.itemMasterServices.deleteQCMonogramById(rowData._id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.getQCMonogramByPMId();
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  }

  setFilterParametersForItemName = (selected, name) => {
    if (selected.value) {
      if (name === "packingMaterialId") {
        let packingMaterialObject = this.state.packingMaterialObject
        packingMaterialObject.packingMaterialId = selected.value;
        packingMaterialObject.specification = selected.specification;
        this.setState({ packingMaterialObject: packingMaterialObject }, () => {
          this.getQCMonogramByPMId()
        });
      } else {
        let testdetails = this.state.testDetails;
        testdetails[name] = selected.value;
        this.setState({ testDetails: testdetails });
      }
    }
  }

  getQCMonogramByPMId = () => {
    this.itemMasterServices.getQCMonogramByPMId(this.state.packingMaterialObject.packingMaterialId).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        this.setState({ tableData: res })
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.testDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  submitQCMonogrampackingMaterial = () => {
    let isValid = this.isValidAllFields();
    if (isValid) {
      let request = {
        packingMaterialId: this.state.packingMaterialObject.packingMaterialId,
        testId: this.state.testDetails.testId,
        result: this.state.testDetails.result,
        limit: this.state.testDetails.limit,
        isOwnLaboratory: this.state.testDetails.isOwnLaboratory,
        monogramType: "PM"
      }
      this.itemMasterServices.addQCMonoGram(request).then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          this.setState({ isLoading: false })
          this.toggleModal();
          this.getQCMonogramByPMId();
          this.resetForm();
          this.SwalServices.Success(response.Message);
        } else {
          this.SwalServices.Error(response.Message);
          this.setState({ isLoading: false })
        }
      });
    }
  }

  resetForm = () => {
    this.setState({
      testDetails: {
        monoGramId: "",
        testId: "",
        testName: "",
        result: "",
        limit: "",
        isOwnLaboratory: 0,
      },
      validState: {
        isValid: true,
        error: {},
      },
    });
  }

  updateQCMonogrampackingMaterial = () => {
    let isValid = this.isValidAllFields();
    if (isValid) {
      let request = {
        monoGramId: this.state.testDetails.monoGramId,
        packingMaterialId: this.state.packingMaterialObject.packingMaterialId,
        testId: this.state.testDetails.testId,
        result: this.state.testDetails.result,
        limit: this.state.testDetails.limit,
        isOwnLaboratory: this.state.testDetails.isOwnLaboratory,
        monogramType: "PM"
      }
      this.itemMasterServices.updateQCMonoGram(request).then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          this.setState({ isLoading: false })
          this.toggleModal();
          this.getQCMonogramByPMId();
          this.resetForm();
          this.SwalServices.Success(response.Message);
        } else {
          this.SwalServices.Error(response.Message);
          this.setState({ isLoading: false })
        }
      });
    }
  }

  openTestDetailsModal = () => {
    if (this.state.packingMaterialObject.packingMaterialId === "") {
      this.SwalServices.Alert("Please select raw material first.");
      return;
    }
    this.resetForm();
    this.setState({ openModel: true })
  }

  render() {
    return (
      <div className="rmFormula-page">
        <div className="item-search">
          <div className="item-grp grid grid-cols-4 gap-2.5">
            <div className="item-search-box col-span-2">
              <label>Item Name</label>
              <MultiSelectDropdown
                drpIdentity="packingMaterialId"
                options={this.state.packingMaterialList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) =>
                  this.setFilterParametersForItemName(selected, "packingMaterialId")
                }
                allowSelectAll={false}
                value={this.state.packingMaterialList.filter(
                  (party) => party.value === this.state.packingMaterialObject.packingMaterialId
                )}
              />
            </div>
            <div className="item-search-box" >
              <label>Specification</label>
              <input
                className="inputFocus"
                type="text"
                id="specification"
                name="specification"
                value={this.state.packingMaterialObject.specification}
                autoComplete="off"
                disabled
              />
            </div>
          </div>
        </div>
        <QCMonogramCommon
          tableData={this.state.tableData}
          columns={this.state.columns}
          openModel={this.state.openModel}
          toggleModal={this.toggleModal}
          handleChange={this.handleChange}
          handleToggle={this.handleToggle}
          testDetails={this.state.testDetails}
          submitQCMonogram={this.submitQCMonogrampackingMaterial}
          updateQCMonogram={this.updateQCMonogrampackingMaterial}
          validState={this.state.validState}
          setFilterParametersForItemName={this.setFilterParametersForItemName.bind(this)}
          testMasterList={this.state.testMasterList}
          openTestDetailsModal={this.openTestDetailsModal}
        />
      </div>
    )
  }
}
